/**
 * * NOTE: @V2 version which is not in use for a feature/Section is moved to Version Management Repo
 * * https://github.com/wisedoc-inc/version-management
 *
 * * We will soon start making npm modules. We do not want to publish them now because we need private npm access which is not free
 */

import fullName from './fullName/v2/updateData';
import tagline from './tagline/v2/updateData';
import email from './email/v2/updateData';
import phoneNumber from './phoneNumber/v2/updateData';
import address from './address/v2/updateData';
import objective from './objective/v2/updateData';
import letterBody from './letterBody/v2/updateData';
import componentSection from '../../../components/userDocuments/editDocument/editResume/EditSpace/LeftPane/componentSection';
import updateUserPreferences from './getUserPreferences/v2/updateData';
import removeEmptyParagraph from './array items/v4/removeEmptyPara';

const getToExportLeftPane = (
  userPreferences,
  sectionIndex,
  nodeType,
  fieldValue,
) => {
  const section = componentSection[nodeType];
  if (section === 'Personal Info') {
    return {
      ...userPreferences.leftPane.used[sectionIndex].toExport,
      [nodeType]: fieldValue,
    };
  }
  return fieldValue;
};

export const getUserPreferences = (params) => {
  const { nodeType, fieldValue } = params;
  let { userPreferences } = params;

  const section = componentSection[nodeType];
  let sectionIndex = 0;
  userPreferences.leftPane.used.some((usedSection, index) => {
    sectionIndex = index;
    if (usedSection.title === section) return usedSection;
    return false;
  });

  userPreferences = {
    ...userPreferences,
    leftPane: {
      ...userPreferences.leftPane,
      used: [
        ...userPreferences.leftPane.used.slice(0, sectionIndex),
        {
          ...userPreferences.leftPane.used[sectionIndex],
          toExport: getToExportLeftPane(
            userPreferences,
            sectionIndex,
            nodeType,
            fieldValue,
          ),
        },
        ...userPreferences.leftPane.used.slice(sectionIndex + 1),
      ],
    },
  };

  return userPreferences;
};

export default (params) => {
  const { fieldType } = params;

  if (fieldType === 'fullName') return fullName(params);
  if (fieldType === 'tagline') return tagline(params);
  if (fieldType === 'email') return email(params);
  if (fieldType === 'phoneNumber') return phoneNumber(params);
  if (fieldType === 'address') return address(params);
  if (fieldType === 'objective') return objective(params);
  if (fieldType === 'letterBody') return letterBody(params);
  if (fieldType === 'userPreferences') return updateUserPreferences(params);
  if (fieldType === 'summary') return removeEmptyParagraph(params);

  return null;
};
